const SNOOZE_DURATION_MS = 24 * 60 * 60 * 1000;

const snoozeKey = (userId: string, announcementId: string) => `pc_announcement_snooze:${userId}:${announcementId}`;

export const isAnnouncementSnoozed = (userId: string, announcementId: string): boolean => {
    try {
        const expiry = Number(localStorage.getItem(snoozeKey(userId, announcementId)));
        return Number.isFinite(expiry) && expiry > Date.now();
    } catch {
        return false;
    }
};

export const snoozeAnnouncement = (userId: string, announcementId: string): void => {
    try {
        localStorage.setItem(snoozeKey(userId, announcementId), String(Date.now() + SNOOZE_DURATION_MS));
    } catch {
        // The component still dismisses the announcement for this session when storage is unavailable.
    }
};
